import * as react_components from "../reactcomponent.js"
import { getGlobalSettings } from "../settings.js"
import { Button } from "../../core/components/button.js";
import { RightFloatingButtonScalor } from "../editor_common_components.js";
import React from "react";
interface IDictionaryEditorProps {
    contextVariables: any;
    onClose();
    onSave(result: string);
    value: any;
}

interface IDictionaryEditorState {
    value: any;
    basePath: string;
}

export class DictionaryPropertyControl extends React.Component<any, any>{
    constructor(props: any, context: any) {
        super(props, context);
        this.state = { showServiceSelector: false, currentValue: props.value, initialValue: props.value };
    }

    handleShowServiceSelector = () => {
        this.setState({ showServiceSelector: true });
    }

    handleClose = () => {
        this.setState({ showServiceSelector: false });
    }

    handleSave = (name) => {
        this.props.onTextChange(name);
        this.setState({ showServiceSelector: false });
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({ currentValue: props.value, initialValue: props.value });
    }

    extractServiceId(url) {
        if (url) {
            var index = url.substring(15, url.length);
            index = index.substring(0, url.indexOf('/') - 1);
            return index;
        }
        return url;
    }

    render() {
        let d;

        if (this.state.showServiceSelector === true) {
            d = <DictionaryEditor contextVariables={this.props.contextVariables} onClose={this.handleClose} onSave={this.handleSave} value={this.props.value} />
        }
        return (
            <li>
                {d}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="search" title="Suche" handleClick={this.handleShowServiceSelector}></Button>
                        </RightFloatingButtonScalor>

                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        <input style={{ backgroundColor: "lightgray" }} readOnly={true} type="text" value={JSON.stringify(this.state.currentValue || '')} />
                    </div>
                </div>
            </li>
        );
    }
};

export class DictionaryEditor extends React.Component<IDictionaryEditorProps, IDictionaryEditorState>{
    constructor(props, context) {
        super(props, context)
        this.state = { basePath: getGlobalSettings().GetSettings().INNO_BASE_PATH, value: props.value ? JSON.parse(JSON.stringify(props.value)) : null };
    }
    handleSelectionChanged = (selectedItem) => {
        //  this.setState({ selectedItem: selectedItem })
    }
    handleOkay = () => {
        this.props.onSave(this.state.value);
    }
    handleDeleteKey = (key: string) => {
        let v = this.state.value;
        delete v[key];
        this.setState({ value: v });
    }
    handleValueChange = (key: string, e) => {
        let v = this.state.value;
        v[key] = e.target.value;
        this.setState({ value: v });
    }
    renderKeyValues = () => {
        if (!this.state.value) {
            return;
        }
        return Object.keys(this.state.value).map((key) => {
            return (<DictionaryEntryRow objectKey={key} value={this.state.value[key]} onChange={this.handleValueChange.bind(this, key)} onDelete={this.handleDeleteKey.bind(this, key)}></DictionaryEntryRow>)
        });
    }
    handleAddNewEntry = (key: string, value: string) => {
        let v = this.state.value;
        if (!v) {
            v = {};
        }
        v[key] = value;
        this.setState({ value: v });
    }
    render() {
        return (
            <react_components.BasicDialog title="Edit key value pairs" onClose={this.props.onClose} onSave={this.handleOkay}>
                <table style={{ width: "100%" }}>
                    <thead>
                        <tr style={{ backgroundColor: "lightgray" }}><th style={{ width: "60px" }}>Action</th>
                            <th>Key</th>
                            <th>Value</th></tr>
                    </thead>
                    <tbody>
                        {this.renderKeyValues()}
                        <tr style={{ backgroundColor: "lightgray" }}><td colSpan={4}>Add new key value pair</td></tr>
                        <NewDictionaryEntry usedKeys={this.state.value ? Object.keys(this.state.value) : []} onAddNewEntry={this.handleAddNewEntry} />
                    </tbody>
                </table>
            </react_components.BasicDialog>
        );
    }
};

export const DictionaryEntryRow = ({ objectKey, value, onChange, onDelete }) => {
    return (<tr><td><button onClick={onDelete}>-</button></td><td>{objectKey}</td><td><input type="text" value={value} onChange={onChange}></input ></td></tr>);

};

export class NewDictionaryEntry extends React.Component<{ usedKeys: string[], onAddNewEntry(key: string, value: string) }, { candAdd: boolean }>{
    private keyInput: HTMLInputElement;
    private valueInput: HTMLInputElement;

    constructor(props) {
        super(props);
        this.state = { candAdd: false }
    }

    handleKeyChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.trim() && (!this.props.usedKeys || this.props.usedKeys.length)) {
            this.setState({
                candAdd: true
            });
        }

        this.setState({ candAdd: this.props.usedKeys.indexOf(e.target.value.trim()) == -1 });
    }

    handleAddClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.props.onAddNewEntry(this.keyInput.value.trim(), this.valueInput.value.trim());
        this.keyInput.value = "";
        this.valueInput.value = "";
        this.setState({ candAdd: false });
    }

    render() {
        return (
            <tr>
                <td><button disabled={!this.state.candAdd} onClick={this.handleAddClick}>+</button></td>
                <td><input ref={el => this.keyInput = el} type="text" onChange={this.handleKeyChanged}></input></td>
                <td><input ref={el => this.valueInput = el} type="text"></input></td>
            </tr>
        );
    }
}
